import { expensePeriodTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { namesList as getDrivers } from "sources/books/drivers";
import { numbersList as getTrailers } from "sources/books/trailers";
import { numbersList as getTrucks } from "sources/books/trucks";
import { resourceEnum, resourceOptions } from "./constants";

const config = {
    resource: {
        label: "Ресурс",
        inputProps: { name: "resource" },
        options: resourceOptions,
        menuPortalTarget: document.body,
        validators: [requiredField],
        required: true,
    },
    carId: {
        label: "Грузовик",
        inputProps: { name: "carId" },
        url: getTrucks,
        propName: "number",
        menuPortalTarget: document.body,
        validators: [(value, data) => (data.resource === resourceEnum.CAR ? requiredField(value) : "")],
    },
    driverId: {
        label: "Водитель",
        inputProps: { name: "driverId" },
        url: getDrivers,
        propName: "fullName",
        menuPortalTarget: document.body,
        validators: [(value, data) => (data.resource === resourceEnum.DRIVER ? requiredField(value) : "")],
    },
    trailerId: {
        label: "Прицеп",
        inputProps: { name: "trailerId" },
        url: getTrailers,
        propName: "number",
        menuPortalTarget: document.body,
        validators: [(value, data) => (data.resource === resourceEnum.TRAILER ? requiredField(value) : "")],
    },
    periodType: {
        label: "Тип периодичности",
        inputProps: { name: "periodType" },
        options: expensePeriodTypes,
    },
    period: {
        label: "Период",
        inputProps: { name: "period", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
        validators: [(value, data) => (data.periodType ? requiredField(value) : "")],
    },
    typeId: {
        label: "Статья затрат",
        inputProps: { name: "typeId" },
        dictionary: "expenseType",
        validators: [requiredField],
        required: true,
        menuPortalTarget: document.body,
    },
    date: {
        label: "Дата затраты",
        inputProps: { name: "date", type: "date" },
        validators: [requiredField],
        required: true,
    },
    value: {
        label: "Сумма расхода",
        inputProps: { name: "value", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
        validators: [requiredField],
        required: true,
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
        textarea: true,
    },
    fileIds: {},
    id: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
